import { render, staticRenderFns } from "./HouseholdMemberDetailedLink.vue?vue&type=template&id=73f72ea5&"
import script from "./HouseholdMemberDetailedLink.vue?vue&type=script&lang=ts&"
export * from "./HouseholdMemberDetailedLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports